import { t } from '../i18n';
import { useAuthStore } from '../store/authStore';
import { useTemporaryTrustedAccessStore } from '../store/temporaryTrustedAccessStore';
import { showToast } from '../utils/toast';

const shownRequestIds = new Set<string>();

type TemporaryTrustedAccessSignal = {
  requestId?: string | null;
  identityId?: string | null;
  temporaryDeviceId?: string | null;
  source: 'ws' | 'push';
};

export function handleTemporaryTrustedAccessSignal(signal: TemporaryTrustedAccessSignal) {
  const identityId = String(signal.identityId || '').trim();
  if (!identityId) return;

  const state = useAuthStore.getState();
  const hasLocalTrustedDevice = Object.values(state.devices).some((device) => device.identityId === identityId);

  if (!hasLocalTrustedDevice) {
    return;
  }

  useTemporaryTrustedAccessStore.getState().markDirty(identityId);

  const requestId = String(signal.requestId || '').trim();
  if (!requestId || shownRequestIds.has(requestId)) return;
  shownRequestIds.add(requestId);

  showToast({
    message: t('temporaryAccessWatcher.newTrustedRequest'),
    variant: 'info',
    durationMs: 20_000,
    actionLabel: t('temporaryAccessWatcher.review'),
    onAction: () => {
      window.location.href = '/settings/trusted-access-requests';
    }
  });
}
